import { createFileRoute, useParams } from '@tanstack/react-router'
import { NoteEditorPage } from '@/pages/Notes/NoteEditorPage'

export const Route = createFileRoute('/notes/$noteId')({
  component: NoteDetailPage,
  head: () => ({
    meta: [{ title: 'Edit Note — Enablar' }],
  }),
})

function NoteDetailPage() {
  const { noteId } = useParams({ from: '/notes/$noteId' })
  return <NoteEditorPage noteId={noteId} />
}
